import React from 'react';
import { Spinner } from '../../components/ui';
import EventForm from './EventForm';
import { fmtDate } from '../../utils/helpers';

export default function EventsMobile({ vm }) {
  const { filtered, loading, can, q, setQ, startAdd, startEdit, del } = vm;
  return (
    <div>
      <div className="page-head">
        <h1>Events</h1>
        <span className="muted">{filtered.length}</span>
      </div>

      <div className="mobile-toolbar">
        <input placeholder="Search..." value={q} onChange={(e) => setQ(e.target.value)}
          style={{ padding: '11px 12px', border: '1px solid var(--line)', borderRadius: 10 }} />
        {can.add && <button className="btn primary" onClick={startAdd}>+ Add Event</button>}
      </div>

      {loading ? <div className="card card-pad"><Spinner /></div>
        : filtered.length === 0 ? (
          <div className="card card-pad empty">No events yet.{!can.add && ' Ask an Admin to create one.'}</div>
        ) : (
          <div className="mobile-card-list">
            {filtered.map(row => (
              <div key={row.EventId} className="card card-pad mobile-record-card row-link" onClick={() => vm.openRow(row)}>
                <div className="mobile-card-head">
                  <strong className="mobile-title">{row.EventName || '-'}</strong>
                  <div style={{ flex: 1 }} />
                  <span className="chip pend">{row.Status}</span>
                </div>
                <div className="mobile-meta">
                  <div>{row.EventTypeName || row.EventType || '-'} | Admin: {row.EventAdminName || row.EventAdminMobile || '-'}</div>
                  <div>{fmtDate(row.EventStartDate)} to {fmtDate(row.EventEndDate)}</div>
                  <div className="muted">{[row.Venue, row.City].filter(Boolean).join(' | ') || '-'}</div>
                </div>
                {(can.edit || can.delete) && (
                  <div className="mobile-actions" onClick={(e) => e.stopPropagation()}>
                    {can.edit && <button className="btn light sm" onClick={() => startEdit(row)}>Edit</button>}
                    {can.delete && <button className="btn danger sm" onClick={() => del(row)}>Del</button>}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}

      <EventForm vm={vm} />
    </div>
  );
}
